import moment from 'moment'

export type IInputDateType = number | string | Date | moment.Moment | null

export const getDateFormatter = (format: string, local = true) => {
  return (date: IInputDateType) => {
    if (!date) return ''
    const dateMoment = local ? moment(date) : moment.utc(date)
    return dateMoment.isValid() ? dateMoment.format(format) : ''
  }
}
